<h1>Select purpose</h1>

<form [formGroup]="form" class="form">
  <p><abbr title="(required)" class="required">*</abbr> For this lot on plan, you can notify for the following clearing
purposes. Please select one:</p>
<ol class="questions">
  <li>
    <ul class="choices">
      @for (p of purposeRefData; track p) {
        <li>
          <input type="radio" [value]="p.purposeCode" id="purpose-{{p.purposeCode}}"
            formControlName="purposeCode" />
            <label for="purpose-{{p.purposeCode}}">{{p.purposeDescription}}</label>
          </li>
        }
      </ul>
    </li>

    @if (purposeQuestionaire && purposeQuestionaire.promptQuestionMessage) {
      <li>
        <fieldset>
          <legend>
            <span class="label">{{purposeQuestionaire.promptQuestionMessage}}</span>
            <abbr title="(required)" class="required">*</abbr>
          </legend>
          <ul class="choices">
            <li>
              <input formControlName="isPurposeMessageAnswerValid" type="radio" id="confirmation-yes" [value]="true" />
              <label for="confirmation-yes">Yes</label>
            </li>
            <li>
              <input formControlName="isPurposeMessageAnswerValid" type="radio" id="confirmation-no" [value]="false" />
              <label for="confirmation-no">No</label>
            </li>
          </ul>
        </fieldset>
        @if (isPurposeMessageAnswerValidControl.value != null && (!isPurposeMessageAnswerValidControl.valid && !isNFPPurposeValid)) {
          <div class="alert alert-warning">
            <p>{{purposeQuestionaire.userSelectsNoDisplayMessage}}</p>
          </div>
        }
        @if (!isNFPPurposeSelected && isPurposeMessageAnswerValidControl.value != null && isPurposeMessageAnswerValidControl.valid) {
          <div class="alert alert-info">
            <p>{{purposeQuestionaire.userSelectsYesDisplayMessage}}</p>
          </div>
        }
        @if ((isPurposeMessageAnswerValidControl.value == null || isPurposeMessageAnswerValidControl.value == undefined) && (isPurposeMessageAnswerValidControl.dirty || isPurposeMessageAnswerValidControl.errors !== null)) {
          <div class="alert alert-warning">
            <span class="requiredIcon fa fa-exclamation-triangle"></span>
            Please select answer
          </div>
        }
      </li>
    }

    @if ((isNFPPurposeSelected && isPurposeMessageAnswerValidControl.value === false) || isNFPPurposeValid) {
      <li>
        <fieldset>
          <legend>
            <span class="label">{{purposeQuestionaire.secondPromptQuestionMessage}}</span>
            <abbr title="(required)" class="required">*</abbr>
          </legend>
          <ul class="choices">
            <li>
              <input formControlName="isSecondPurposeMessageAnswerValid" type="radio" id="second-confirmation-yes" [value]="true" />
              <label for="second-confirmation-yes">Yes</label>
            </li>
            <li>
              <input formControlName="isSecondPurposeMessageAnswerValid" type="radio" id="second-confirmation-no" [value]="false" />
              <label for="second-confirmation-no">No</label>
            </li>
          </ul>
        </fieldset>
        @if (isSecondPurposeMessageAnswerValidControl.value != null && isSecondPurposeMessageAnswerValidControl.value === false) {
          <div class="alert alert-warning">
            <p>{{purposeQuestionaire.secondUserSelectsNoDisplayMessage}}</p>
          </div>
        }
        @if (isSecondPurposeMessageAnswerValidControl.value === null && isSecondPurposeMessageAnswerValidControl.dirty && nextSecondButtonClicked) {
          <div class="alert alert-warning">
            <span class="requiredIcon fa fa-exclamation-triangle"></span>
            Please select answer
          </div>
        }
      </li>
    }
  </ol>
  @if (purposeCodeControl.value === null && form.dirty) {
    <div class="alert alert-warning">
      <p>Please select a purpose to continue with the notification.</p>
    </div>
  }
  <li class="footer">
    <ul class="actions">
      <li> <input class="qg-btn btn-global-secondary" type="button" (click)="previous()" value="Previous" /> </li>
      <li> <em> <input class="qg-btn btn-primary" type="submit" (click)="next()"
      value="Next" in-progress-text="Saving..."/> </em> </li>
    </ul>
    <ul class="actions">
      <li>
        <a href="#" (click)="cancel()">Cancel</a>
      </li>
    </ul>
  </li>
</form>
